import {Link} from '@mui/material'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

export const REFERENCES_LINK_TITLE_MARGIN_BOTTOM = 3

type ReferencesLinkProps = {
  guidanceLink: string
  color?: string
}

export const ReferencesLink: FC<ReferencesLinkProps> = ({
  guidanceLink,
  color = 'text.primary'
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Link
      color={color}
      href={guidanceLink}
      target="_blank"
      rel="noopener noreferrer"
      variant="caption"
      data-test-id="question-detail-link"
      sx={{
        display: 'inline-flex',
        mb: REFERENCES_LINK_TITLE_MARGIN_BOTTOM,
        ml: 3,
        fontSize: 16,
        '&:hover': {
          textDecoration: 'underline'
        }
      }}
    >
      {t('questionnaire.moreInformation')}
    </Link>
  )
}
